module.exports = __webpack_public_path__ + "img/more-vertical.2f90bb14.svg";